<template>
  <div class="mb-3">
    <b for="name" v-if="label" class="form-label"> {{ label }} </b>
    <VueDatePicker range v-model="internalValue" :disabled="disabled" :readonly="readonly" locale="fr"
      :cancelText="i18n.t('button.cancel')" :selectText="i18n.t('button.select')" :enable-time-picker="false"
      :max-date="maxDate" />
    <span v-if="v">
      <span class="text-danger" v-for="error in v?.$errors" :key="error.$uid">
        - {{ error.$message }} <br>
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch, defineProps, defineEmits, PropType } from 'vue';
import i18n from "@/i18n/index"

const props = defineProps({
  modelValue: {
    type: Array as PropType<Date[] | null>, // Use PropType to define the type
    default: null,
  },
  type: { type: String, default: 'text' },
  readonly: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },

  label: { type: String },
  typeStyle: { type: String, default: "" },
  v: {
    type: Object,
  },

  fixedDays: { type: Number, default: 1 },
  isFixedDays: { type: Boolean, default: false },
});



const maxDate = computed(() => {
  if (props?.isFixedDays) {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Ensure two digits for month
    return `${year}-${month}-${props?.fixedDays ?? 1}T01:00:00Z`;
  }
  return false
});

const emits = defineEmits(['update:modelValue']);

const internalValue = ref<Date[] | null>(props.modelValue);

watch(internalValue, (newValue) => {
  if (newValue) {
    if (newValue?.length >= 2) {
      if (newValue[0] instanceof Date && newValue[1] instanceof Date) {
        console.log(newValue[1])
        emits('update:modelValue', [
          newValue[0].toISOString().split('T')[0],
          newValue[1].toISOString().split('T')[0]
        ]);
      }
    } else {
      emits('update:modelValue', [
        null,
        null
      ]);
    }
  }
});

watch(() => props.modelValue, (newValue) => {
  internalValue.value = newValue;
});



</script>

<style>
/* Add any necessary styles here */
</style>
